<div @fadeInOut class="w-screen h-screen fixed top-0 left-0 bg-black/70 z-[5000] flex items-center justify-center">
    <div class="loader"></div>
</div>